export default __webpack_public_path__ + "static/media/personDoge.b0d13fa8.png";